<template>
    <div style="width: 180px" class="filepond-uploader-width">
        <input
            :id="'profile-' + (props.id ? props.id : props.context.id)"
            :name="fileName"
            type="file"
            class="profileUpload"
            @change="handleInputFile"
        />
    </div>
</template>

<script setup>
import { onMounted, ref, nextTick, watch } from 'vue';
import { getNode } from '@formkit/core';
import {
    // Pintura editor components needed for integration with FilePond
    openEditor,
    processImage,
    createDefaultImageReader,
    createDefaultImageWriter,
    legacyDataToImageState,
    // Import the editor default configuration
    getEditorDefaults,
} from '@/assets/filepond/pintura/pintura.js';
import FilePondPluginImageEditor from '@/assets/filepond/filepond-plugin-image-editor/FilePondPluginImageEditor.js';
import FilePondPluginPdfPreview from 'filepond-plugin-pdf-preview';
import FilePondPluginGetFile from 'filepond-plugin-get-file';

const emit = defineEmits(['userImage', 'addedFile']);

const props = defineProps({
    context: Object,
    isProfile: {
        type: Boolean,
        default: false,
    },
    modelValue: {
        type: [String, Number],
        default: '',
    },
    serverUrl: {
        type: String,
        default: '',
    },
    fileName: {
        type: [String, Number],
        default: '',
    },
    id: {
        type: [String, Number],
        default: '',
    },
    fileSource: {
        type: Array,
        default: () => [],
    },
    fileType: {
        type: String,
        default: '',
    },
    uuid: {
        type: String,
        default: '',
    },
    folderName: {
        type: String,
        default: '',
    },
});

var profileImage = ref('');
const appImages = ref(null);
const uploadPond = ref(null);
const pond = ref();
const filesData = ref(props && props.context && props.context.filesData ? props.context.filesData : '' );

// emit image data
const myArray = ref([]);
const handleInputFile = (data) => {
    // console.log(data, 'data pintura');
    myArray.value.push(data);
    // console.log(myArray.value, 'myArray.value');
    getNode(props.context.id).input(myArray);
    emit('data', data);
};

const handleFileRemoval = (file) => {
    // console.log(file.file.name, 'myArray.value file');
    // If you're using file id to store files in the 'myArray'
    const index = myArray.value.findIndex(
        (item) => item.name === file.file.name
    );

    if (index > -1) {
        myArray.value.splice(index, 1);
    }
    // console.log(myArray.value, 'myArray.value handleremove');
    getNode(props.context.id).input(myArray);
};

emit('addedFile', uploadPond.value);
let imagesToShow = ref([]);
// Register FilePond plugins
const initFilepond = async (myfile) => {
    FilePond.registerPlugin(
        FilePondPluginFileValidateType,
        FilePondPluginImageEditor,
        FilePondPluginFilePoster,
        FilePondPluginGetFile
    );
    const input = document.querySelector(
        '#profile-' + (props.id ? props.id : props.context.id)
    );

    // Default FilePond field
    uploadPond.value = FilePond.create(input, {
        /* FilePond properties */
        stylePanelLayout: 'compact circle',
        styleLoadIndicatorPosition: 'center bottom',
        styleProgressIndicatorPosition: 'right bottom',
        styleButtonRemoveItemPosition: 'left bottom',
        styleButtonProcessItemPosition: 'right bottom',
        allowReorder: true,
        filePosterMaxHeight: 256,
        storeAsFile: true,
        allowDownloadByUrl: false,
        labelButtonDownloadItem: 'custom label',
        // acceptedFileTypes:["*"],
        imageEditorAfterWriteImage: (res) => {
            // console.log(res, 'durrr pinturayyy oneeeee');
            myfile = res.dest;
            handleInputFile(myfile);
            return myfile;
            //console.log(myfile);
            // profileImage.value.push(
            //     { name: 'input_', file: res.src },
            //     { name: 'output_', file: res.dest }
            // );
        },

        onremovefile: (error, file) => {
            handleFileRemoval(file);
        },
        onactivatefile: (e, o) => {
            // const fileItem = FilePond.getFile();
            // const file = fileItem.file;
            // const link = document.createElement('a');
            // link.download = file.name;
            // link.href = URL.createObjectURL(file);
            // link.click();
        },
        /* Image Editor plugin properties */
        imageEditor: {
            // used to create the editor, receives editor configuration, should return an editor instance
            createEditor: openEditor,

            // Required, used for reading the image data
            imageReader: [createDefaultImageReader],

            // optionally. can leave out when not generating a preview thumbnail and/or output image
            imageWriter: [
                createDefaultImageWriter,
                // optional image writer instructions, this instructs
                // the image writer to resize the image to match a width of 384 pixels
                {
                    targetSize: {
                        width: 384,
                    },
                },
            ],

            // used to generate poster images, runs an editor in the background
            imageProcessor: processImage,

            // Pintura Image Editor properties
            editorOptions: {
                // pass the editor default configuration options
                ...getEditorDefaults(),

                // we want a square crop
                imageCropAspectRatio: undefined,
            },

            // map legacy data objects to new imageState objects, uncomment if you've used FilePond with version 6 of Pintura and are loading old file metadata
            // legacyDataToImageState: legacyDataToImageState,
        },

        /* uncomment to preview the output image
        onpreparefile: (fileItem, file) => {
            const image = new Image();
            image.src = URL.createObjectURL(file);
            document.body.appendChild(image);
        },
        */
    });
};

// let fileSources = ref('https://pms6-bucket.s3.ap-south-1.amazonaws.com/99e8106b-4a5d-4531-a0e3-1fdddaef8d73/contacts/99e81487-090b-4b22-ba91-75a83be73b7c.png');
if (props.context != undefined) {
    // debugger;
    const filePondToShow = getNode(props.context.id);
    if (filePondToShow.value != undefined);
}
onMounted(async () => {
    await initFilepond();
    imagesToShow.value = [];
    if (filesData.value) {
        uploadPond.value.addFile(filesData.value);
    }
    
    if (props.context.isGrid) {
        gridCss.value.width = 'calc(33.33% - 0.5em)';
        gridCss.value.height = '100px !important';
        //  width:'calc(33.33% - 0.5em)',
        // height:'100px !important'
    }
    nextTick(() => {
    });
    // })
});
const array = ref([
    {
        contacts: [],
        title: '',
        message: {},
        activity: [],
        waiting: '',
        users: [],
        status: 1,
        label: [],
    },
]);
let nfiles = 0;

let gridCss = ref({
    width: '',
    height: '',
    //  width:'calc(33.33% - 0.5em)',
    // height:'100px !important'
});
</script>
<style>
@import 'filepond-plugin-get-file/dist/filepond-plugin-get-file.min.css';
/*.filepond--item {*/
/*    width: calc(33.33% - 0.5em);*/
/*    height: 100px !important;*/
/*}*/
.filepond--item {
    width: v-bind(gridCss.width);
    height: v-bind(gridCss.height);
}
</style>
